// This is a magic string replaced by rollup
var SDK_VERSION = "9.0.1";
export { SDK_VERSION };